import type { IAppointment, IAppointmentTour } from '@bb/domain/dist/types';

export { TourItemContentDTO as TourItemContent } from '@bb/domain/dist/types/dto/TourController/TourItemContent';

export type RouteInfo = {
  distance: string;
  duration: string;
};

export type Tour = Omit<
  IAppointmentTour,
  'createdAt' | 'updatedAt' | 'isDeleted' | 'coopId' | '_id' | 'buyers'
> & {
  id: string;
  coopId: string;
  buyers: { key: string; value: string; label: string }[];
  pendingBuyers?: boolean;
};

export enum OptimizeStatus {
  NOT_OPTIMIZED = 'NOT_OPTIMIZED',
  OPTIMIZING = 'OPTIMIZING',
  OPTIMIZED = 'OPTIMIZED',
}

export type TourListingPhoto = {
  id: string;
  url: string;
  filename: string;
};

export type TourListingAttachment = {
  id: string;
  uid: string;
  url: string;
  mimetype: string;
  filename: string;
  size?: number;
};

export enum TourModalType {
  LISTING = 'LISTING',
  APPOINTMENT = 'APPOINTMENT',
  RESCHEDULE = 'RESCHEDULE',
}

export enum TourAutoSaveStatus {
  UNSAVED = 'UNSAVED',
  SAVED = 'SAVED',
  SAVING = 'SAVING',
  ERROR = 'ERROR',
  ERROR_RETRIED = 'ERROR_RETRIED',
}

export type StatusUpdateType = 'email' | 'text' | 'office' | 'email&text';

export type SendAppointmentError = {
  error: string;
  tourItemId: string;
  timeNotAvailable?: boolean;
};

export type SendAppointmentResponse = [IAppointment | SendAppointmentError];
export enum TourCancelType {
  LAST_ITEM = 'LAST_ITEM',
  WITH_SUBMITTED_SHOWING = 'WITH_SUBMITTED_SHOWING',
  WITHOUT_SUBMITTED_SHOWING = 'WITHOUT_SUBMITTED_SHOWING',
  SUGGESTION_ACCEPT = 'SUGGESTION_ACCEPT',
  SUGGESTION_DENY = 'SUGGESTION_DENY',
  SUGGESTION_CANCEL = 'SUGGESTION_CANCEL',
  SUGGESTION_CANCEL_LAST = 'SUGGESTION_CANCEL_LAST',
}
